/**
 * Legacy code for retrieving non-rollouts Optimizely variants
 */

export const getFeatures = ({ features }) => features

export const getGoToMyGousto = ({ features }) =>
  (features ? features.getIn(['goToMyGousto', 'value']) : false)

export const getGoToMyDeliveries = ({ features }) =>
  (features ? features.getIn(['goToMyDeliveries', 'value']) : false)

export const getFullScreenBoxSummary = ({ features }) =>
  features && features.getIn(['fullScreenBoxSummary', 'value'], false)
